import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASettingsSection = ({ formData, errors, onChange }) => {
  const previewCTA = () => {
    return (
      <div className="bg-muted rounded-lg p-6 flex items-center justify-between">
        <div>
          <p className="text-sm text-text-secondary mb-2">CTA Button Preview</p>
          <Button
            variant="default"
            style={{
              backgroundColor: formData?.primaryColor,
              borderColor: formData?.primaryColor
            }}
          >
            {formData?.ctaText || 'Get Quote'}
          </Button>
        </div>
        <div className="text-right">
          <p className="text-xs text-text-secondary mb-1">Links to:</p>
          <p className="text-sm font-medium text-text-primary truncate max-w-xs">
            {formData?.ctaUrl || 'Not set'}
          </p>
        </div>
      </div>
    );
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="MousePointerClick" size={20} className="text-primary" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-text-primary">Call-to-Action Settings</h2>
          <p className="text-sm text-text-secondary">Configure customer action button</p>
        </div>
      </div>
      <div className="space-y-4">
        <Input
          label="CTA Button Text"
          type="text"
          name="ctaText"
          value={formData?.ctaText}
          onChange={onChange}
          placeholder="Get a Free Quote"
          error={errors?.ctaText}
          description="Text displayed on the action button"
        />

        <Input
          label="CTA Button URL"
          type="url"
          name="ctaUrl"
          value={formData?.ctaUrl}
          onChange={onChange}
          placeholder="https://www.company.com/quote"
          error={errors?.ctaUrl}
          description="Where the button redirects customers"
        />

        {previewCTA()}

        <div className="p-4 bg-muted rounded-lg">
          <div className="flex items-start gap-3">
            <Icon name="Lightbulb" size={16} className="text-primary mt-0.5" />
            <div className="text-sm text-text-secondary">
              <p className="font-medium text-text-primary mb-1">Best Practices</p>
              <ul className="list-disc list-inside space-y-1">
                <li>Use action-oriented text (e.g., "Get Quote", "Contact Us")</li>
                <li>Link to a contact form or quote request page</li>
                <li>Ensure the URL is accessible and mobile-friendly</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTASettingsSection;